import Label from "@ingka/label";
import { Select, Option } from "@ingka/select";
import FormField from "@ingka/form-field";
import LabelWithToolTip from "@/components/LabelWithTooltip/LabelWithToolTip";
import { useMetadataFields } from "@/components/MetadataFields/hooks";
import {
  FieldAccessContext,
  isLockedForNonAdmin,
  isUploadFinalized,
} from "@/components/MetadataFields/formFieldsAccessRules";

type CopyrightProps = {
  options: Record<string, string>;
  fieldAccessContext: FieldAccessContext;
};

export function Copyright({ options, fieldAccessContext }: CopyrightProps) {
  const {
    getValidationError,
    activeAsset,
    updateMetadata,
    isMetadataUpdating,
  } = useMetadataFields();
  const error = getValidationError("copyright", activeAsset.id!);
  const isDisabled =
    isLockedForNonAdmin(fieldAccessContext) ||
    isMetadataUpdating(activeAsset.id!, "copyright") ||
    isUploadFinalized(fieldAccessContext);

  return (
    <>
      <Label
        htmlFor="copyright"
        label={
          <LabelWithToolTip
            labelText="Copyright"
            toolTipText="Inter IKEA Systems B.V. copyright protects IKEA intellectual property from being copied without permission. This is normally embedded in the file when created but should be embedded to all DAM/Barn assets avoid uncertainty."
          />
        }
      />
      <FormField
        valid="error"
        validation={{
          msg: error?.message,
          type: "error",
        }}
        shouldValidate={Boolean(error)}
      >
        <Select
          id="copyright"
          value={activeAsset.copyright || ""}
          disabled={isDisabled}
          onChange={(e) => {
            updateMetadata({
              copyright: e.target.value,
            });
          }}
        >
          {Object.entries(options).map(([name, label]) => (
            <Option key={name} name={label} value={name} />
          ))}
        </Select>
      </FormField>
    </>
  );
}
